/**
 * Event Bus
 * A helper singleton to organize event handling and decoupling components using the publisher/subscriber pattern. 
 * It also helps minimizing global events on document base.
 *
 * Available Methods:
 * 
 * Subscribe:
 * const subscription = EventBus.subscribe(
 *      "print",
 *      message => console.log(`printing: ${message}`)
 * )
 *
 * Unsubscribe:
 * subscription.unsubscribe();
 * 
 * Publish:
 * EventBus.publish("print", "some text")
 *
 */
const subscriptions = { }
const getNextUniqueId = getIdGenerator()

function subscribe(eventType, callback) {
    const id = getNextUniqueId()

    if(!subscriptions[eventType])
        subscriptions[eventType] = { }

    subscriptions[eventType][id] = callback

    return { 
        unsubscribe: () => {
            delete subscriptions[eventType][id]
            if(Object.keys(subscriptions[eventType]).length === 0) delete subscriptions[eventType]
        }
    }
}

function publish(eventType, arg) {
    if(!subscriptions[eventType])
        return

    Object.keys(subscriptions[eventType]).forEach(key => subscriptions[eventType][key](arg))
}

function getIdGenerator() {
    let lastId = 0
    
    return function getNextUniqueId() {
        lastId += 1
        return lastId
    }
}

export default { publish, subscribe }



// WEBPACK FOOTER //
// ./src/config/eventBus.js